import {addToDataLayer} from "../other/gtm_layer.js";
import showErrors from "../errors/showErrors.js";
import checkCaptcha from "../other/check_captcha.js";

export default async function () {
    this.disableInputs();

    try {
        this.loading = true;

        let form_data = new FormData;
        form_data.append('re_token', await checkCaptcha());
        form_data.append('action', ajax_var.action_register_signin_legacy);
        form_data.append('userData', JSON.stringify(this.userData));
        form_data.append('nonce', ajax_var.nonce);

        const response = await axios.post(ajax_var.url, form_data);
        if (this.mailingListCheck === 1 && this.current === 'zipcode') {
            const subscriptionRequest = new GSSaveSubscriptionRequest(this.userData.email, ajax_var.user_ip, "");
            subscriptionRequest.sendRequestNoCaptcha();
        }

        this.loading = false;
        let data = response.data.data;

        if (data) {

            this.enableInputs();

            if (data.isSignUp) {
                addToDataLayer('Successful submission', 'Submit', 'Subscription form Trueleaf', '');
            }

            if (ajax_var.redirect_to) {
                window.location.href = ajax_var.redirect_to;
                return;
            }

            this.carrotOpened = true;
            this.userStatus = response.data.status;

            this.$router.push('/welcome/');
            this.loading = false;
            return;
        }

        let errorMsg = 'Sorry, an error occurred';
        if (response?.data?.message) {
            errorMsg = data.message;
        } else if (response?.data?.data?.message) {
            errorMsg = data.data.message;
        }

        throw new Error(errorMsg);
    } catch (error) {
        showErrors.call(this, 'registration_signin_legacy', error);
        this.loading = false;
        this.enableInputs();
    }
};
